import { map, objOf } from 'ramda'

// eslint-disable-next-line import/prefer-default-export
export const mapObjOfValue = map(objOf(`value`))
